import axios from 'axios';

// const baseURL = 'BASEURL_TBD'; //process.env.REACT_APP_BACKEND_URL;
// const baseURL = process.env.REACT_APP_BACKEND_URL;
const baseURL = import.meta.env.VITE_BACKEND_URL;

if (!baseURL) {
  // Aide au debug si la variable n’est pas définie
  console.warn(
    "[Axios] VITE_BACKEND_URL est indéfini. Vérifie ton fichier .env et le préfixe VITE_."
  );
}

// let headers: any = {};

// if(localStorage.token) {
//     headers.Authorization=`Bearer ${localStorage.token}`;
// }

const axiosInstance = axios.create({
  baseURL,
    // baseURL: baseURL,
    // headers,
});


// ✅ Injection dynamique du token
axiosInstance.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});


axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      // logout / redirect
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
